<template>
  <div>
    <!-- 面包屑导航 -->
  <div class="flexc-cen-x fixed">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{WZHYName}}等级</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
  </div>
    <!-- 搜索筛选 -->
  <el-form :inline="true" :model="formInline" class="flex-r-x" style="padding-top:30px">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="mini" type="primary" v-if="q1 == true" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

  </el-form>
    <!--列表-->
      <div style="height:65vh;overflow:auto;">
    <el-table  :data="tableData" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="LevelName" label="等级名称">
            
        </el-table-column>
        <!-- <el-table-column  prop="preferentialType" label="优惠类别" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 0 " style="margin-top:5px;font-size:15px">无</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;font-size:15px">减免</div>
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;font-size:15px">打折</div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column  prop="preferentialvalue" label="折扣" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 0 " style="margin-top:5px;font-size:15px">无</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;font-size:15px">{{scope.row.preferentialvalue}}元</div>
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;font-size:15px">{{scope.row.preferentialvalue}}%</div>
            </div>
          </template>
        </el-table-column>


      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" v-if="q2 == true">编辑</el-button>
          <!-- <el-button v-if="scope.row.Isdisable == 0" type="warning" plain size="mini" @click="handlejie(scope.row)">禁用</el-button>
           <el-button v-if="scope.row.Isdisable == 1" type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="setLimits(scope.row)" >权限配置</el-button>
   -->
          <el-button size="mini" type="info" @click="deleteUser(scope.row)" v-if="q3 == true">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      </div>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
         <el-form-item label="等级名称:" prop="LevelName">
          <el-input size="small" v-model="editForm.LevelName" auto-complete="off" placeholder="请输入等级名称"  style="width: 215px"></el-input>
        </el-form-item>
         <!-- <el-form-item label="优惠类别:" prop="preferentialType">
            <el-radio-group v-model="editForm.preferentialType">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">减免</el-radio>
                <el-radio :label="2">打折</el-radio>
            </el-radio-group>
         </el-form-item> -->
        <el-form-item v-if="editForm.preferentialType == 1" label="优惠金额:" prop="preferentialvalue">
          <el-input type="Number" size="small" v-model="editForm.preferentialvalue" auto-complete="off" placeholder="请输入优惠金额"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.preferentialType == 2" label="折扣:" prop="preferentialvalue">
          <el-input type="Number" size="small" v-model="editForm.preferentialvalue" auto-complete="off" placeholder="请输入折扣"  style="width: 215px"></el-input> %
        </el-form-item>
        
        <!-- <el-form-item label="备注:" prop="Note">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item> -->
    
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
        
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>


    <!-- <el-drawer :wrapperClosable= false title="权限配置" :visible.sync="quanxian" :direction="direction" size="30%">
        <el-tree
                    :data="typeList"
                    :props="props"
                    show-checkbox
                    ref="tree"
                    default-expand-all
                    :check-strictly="true"
                    node-key="LType">
                </el-tree>
      
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="baocun"
            >保存</el-button
          >
        </div>
    </el-drawer> -->
    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      DianList:[],
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'listsub',
          label: 'Name'
        },
       direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      Pwd:'',
      RoleID:'',
      SelectStoresID:localStorage.getItem("StoresID"),
      editForm: {
        preferentialType:2,
        LevelName:'',
        preferentialvalue:'',
      },
      // rules表单验证
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      rules: {
        LevelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
      if(localStorage.getItem('isAdmin') == 1){

          this.q1 = true
          this.q2 = true
          this.q3 = true

      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 862)
            this.q1  =true
            if(items == 863)
            this.q2 = true
            if(items == 864)
            this.q3 = true

      })
    //    this.getType()
    this.getList()
    this.getDianList()
    //   this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersLevelID:row.ID,
        
        }
        var that = this
        this.ajax('delMembersLevel.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑等级'
       
              this.editForm = row
              this.editForm.preferentialType = Number(this.editForm.preferentialType) 
    
          } else {
              this.title = '添加等级'
                this.editForm = {
                    preferentialType:2,
                    LevelName:'',
                    preferentialvalue:100,
                }
          }
          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
        //   pages:this.formInline.page,
        //   psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListMembersLevel.aspx ',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title == '添加等级'){
                this.ajax('addMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.MembersLevelID =  this.editForm.ID
                 this.ajax('editMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/vipLevel.vue